module.exports = __webpack_public_path__ + "officialStatic/img/logo13.601d728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo13.png
// module id = Epnq
// module chunks = 0